import styled, { createGlobalStyle } from 'styled-components';
import { compose } from '../../utils/compose';
import { withStrictMode } from '../../utils/with-strict-mode';
import { withLocalization } from '../../shared/Context/LocalizationContext';
import { withServerStyles } from '../../shared/ServerStylesConditionalWrapper';
import { InsightsLandingComponent } from '../InsightLandingComponent';
import { device } from '../../../utils/styled-component-mixins';

const ContainerStyles = createGlobalStyle`
  .card-grid-wrapper {
    padding-inline: 0 !important;
  }
`;

const TrendingTopicInsightList = (props) => (
  <div className={props.className}>
    <ContainerStyles />
    <InsightsLandingComponent {...props} isTrendingTopicLanding />
  </div>
);

const StyledTrendingTopicInsightList = styled(TrendingTopicInsightList)`
  margin-bottom: 8rem;
  background: var(--white);
  margin-inline: 1.5rem;
  position: relative;

  @media ${device.desktop} {
    padding: 2.4rem;
    margin-inline: 4.6rem;
  }

  .select-input-wrapper {
    padding-inline: 0;

    @media ${device.deviceOnly} {
      margin-inline: -1.5rem;
      padding-inline: 1.5rem;
      width: unset;
      max-width: unset;
    }

    .select-selected button {
      margin-inline: auto;
      display: inline-flex;
    }
  }
`;

export default compose(
  withStrictMode,
  withLocalization,
  withServerStyles
)(StyledTrendingTopicInsightList);
